import React from "react";
import "./book-room.less";
import { setHeader } from '@/util/set-header'
import { roomTypeListApi, reservePreRoomApi } from "@/api/sany";
// import Waterfall from 'react-waterfall-h5';
import Cookies from "universal-cookie";
import { phonePlatform } from "@/util/util";
import {
  Button,
  Icon,
  Toast,
  Calendar,
  Modal
} from 'antd-mobile'
import { withRouter } from 'react-router'
const cookie = new Cookies()
const extra: any = {
  '2017/07/15': { info: 'Disable', disable: true },
}
const now = new Date()
@(withRouter as any)
export default class RoomList extends React.Component<any, any> {
  lv: any
  dataBlobs: any = {}
  mainDiv!: any
  rowIDs: any = []
  isHasMore = true
  type = '0'
  // pageIndex = 1
  constructor(prop: any) {
    super(prop)
    window.scroll(0,0)
    this.mainDiv = React.createRef()
    this.state = {
      showModal: false,
      imgList:[],
      sany_communityId:'',
      storeName: sessionStorage.getItem('sanyStoreName') || '默认园区',
      isLineup: sessionStorage.getItem('sanyStoreQueue') || '0',
      storeId: sessionStorage.getItem('sanyStoreId') || '',
      cityName:sessionStorage.getItem('sanyCityName'),
      cityId: sessionStorage.getItem('sanyCityId'),
      property: this.props.location.state&&this.props.location.state.changeProperty === '员工宿舍' ? '3' : '1',
      isLoading: true,
      showAlert: false,
      alertMsg: '你所在的园区暂无对应的员工宿舍，已为您切换到默认园区。',
      // height: (document.documentElement.clientHeight * 3) / 4,
      config: {},
      show: false,
      totalDays: 1,
      startDate: this.date(new Date(+now)),
      endDate: this.date(new Date(+now + (61920000))),
      days: '1',
      defaultStartTime: new Date(+now),
      // defaultEndTime: new Date(+now + 61920000),
      defaultEndTime: new Date(+now + (61920000)),
    }
    //绑定this ios低版本不兼容箭头函数
    this.genData = this.genData.bind(this)
    this.bookInfo = this.bookInfo.bind(this)
    this.leftClick = this.leftClick.bind(this)
    this.goHomePage = this.goHomePage.bind(this)
    this.jumpStoreList = this.jumpStoreList.bind(this)
  }
  componentDidMount() {
    setHeader({ title: '住宿申请', leftToHome: this.goHomePage, leftClick: this.leftClick, right: this.rightBtn() })
    // const hei = document.documentElement.clientHeight - (ReactDOM.findDOMNode(this.mainDiv.current) as any).getBoundingClientRect().top
    this.setState({
      // height: hei,
      sany_communityId: cookie.get('sany_communityId'),
      storeName: cookie.get('sanyStoreName'),
      storeId: cookie.get('sanyStoreId'),
      startDate: this.date(new Date(+now)),
      endDate: this.date(new Date(+now + (61920000))),
    })
    this.genData()
  }
  rightBtn() {
    return (
      <div style={{ display: 'flex', fontSize: '12px' }} onClick={() => this.jumpStoreList()} >
        <div className="text-ell" style={{ marginTop: '5px',width:'100px',textAlign:'right' }}>{this.state.storeName}</div>
        <div><Icon type="down" /></div>
      </div>
    )
  }
  jumpStoreList() {
    // TODO: 新的选择园区页面
    this.props.history.push({ pathname: '/sany/change-park' })
    // 存接口取到的城市id和城市name
    sessionStorage.setItem('sanyCityId', this.state.cityId)
    sessionStorage.setItem('sanyCityName', this.state.cityName)
  }
  leftClick() {
    //返回App
    if (sessionStorage.getItem('reservationType') === 'reservation') {
      this.props.history.push({
        pathname: '/sany/dorm-list',
      })
    } else if(sessionStorage.getItem('reservationType') === 'changeBed'){
      this.props.history.push({
        pathname: '/sany/change-bed',
      })
    } else {
      window.location.href = "uhomeoc://thirdparty.goBack?params={type:native}"
    }
  }

  goHomePage() {
    this.props.history.replace('/sany/dorm-list')
  }

//分页请求
async genData() {
  this.setState({
    isLoading: true,
  })
  const obj = {
    store_id: sessionStorage.getItem('sanyStoreId') ||  cookie.get('sany_communityId'),
    start_day: null,
    end_day: null,
    phone: cookie.get('sany_phone'),
    property: sessionStorage.getItem('reservationType') === 'reservation' ? this.props.location.state&&this.props.location.state.propertyType : this.state.property,
    sourceType: sessionStorage.getItem('reservationType') || 'reservation'
  }
  console.log(obj, 'objobj')
  if (obj.property === '1') {
    obj.start_day = this.state.startDate
    obj.end_day = this.state.endDate
  } else {
    obj.start_day = null
    obj.end_day = null
  }
  Toast.loading('加载中...')
  const {data} = obj.property === '1' ? await reservePreRoomApi(obj) : await roomTypeListApi(obj)
  Toast.hide()
  this.setState({
    isLoading: false,
  })
  if (data.code === 'SUCCESS') {
    if(data.data.DataList.length < 1) {
      Toast.info('没有可预订房源')
    }
    this.setState({
      imgList: data.data.DataList
    })
    if(!(sessionStorage.getItem('sanyStoreId'))) {
      if (cookie.get('sany_communityId') !== data.data.Store.sy_community_id) {
        // this.setState({
        //   showAlert: true
        // })
        // 设置默认门店 星沙园区  12151117  165  test159
        cookie.set('sany_communityId', '12151117')
        await this.genData()
        return
      }
      sessionStorage.setItem('sanyStoreQueue', data.data.Store.is_queue)
      this.setState({
        cityId:data.data.Store.id,
        cityName:data.data.Store.name,
        storeName:data.data.Store.storeName,
        isLineup: data.data.Store.is_queue,
        // storeId:data.data.Store.sy_community_id,
        storeId:data.data.Store.storeId,
      }, async()=> {
        setHeader({ title: '预订房间', leftToHome: this.goHomePage, leftClick: this.leftClick, right: this.rightBtn() })
      })
    } else {
      this.setState({
        storeName:sessionStorage.getItem('sanyStoreName'),
        storeId:sessionStorage.getItem('sanyStoreId')
      },async()=>{
        setHeader({ title: '预订房间', leftToHome: this.goHomePage, leftClick: this.leftClick, right: this.rightBtn() })
      })
    }
  } else {
    Toast.info(data.msg)
  }
}
  //预订
  bookInfo(item: any) {
    console.log(this.state.startDate, this.state.endDate, '1111111111')
    if (item.property === '1' && item.bedCount === '0') {
      Toast.info('暂无剩余床位可预定~')
      return
    }
    if (item.property === '3' && item.isReserve !== '0') {
      if (this.state.isLineup === '1') {
        Toast.info('您当前已有排队中的申请，不可再申请了~')
      } else {
        Toast.info('您当前已有预订中的申请，不可再申请了~')
      }
      return
    }
    if (item.property === '3') {
      if (this.state.isLineup === '1') {
        this.props.history.push({ pathname: '/sany/lineup-info', state: {roomId: item.id, storeId: this.state.storeId, tab: this.state.tab }})
      } else {
        this.props.history.push({ pathname: '/sany/book-info', state: {roomId: item.id, propertyTab: item.property}})
      }
    } else {
      this.props.history.push({ pathname: '/sany/book-info', state: {roomId: item.id,  propertyTab: item.property, start: this.state.startDate, end: this.state.endDate}})
    }
    // 取到换房路由传参过来的值传递给b
    sessionStorage.setItem('roomInfo', JSON.stringify(Object.assign(item,{storeName:this.state.storeName,storeId:this.state.storeId})))
  }
   // 选择日期
  onDateSelect = () => {
    this.setState({
      showModal: true,
      show: true,
      config: {
        defaultValue: [this.state.defaultStartTime, this.state.defaultEndTime],
      },
    })
  }
  // 关闭日历
  onCancel = () => {
    this.setState({
      show: false
    })
  }
  // 确认日期
  onConfirm = (startTime: any, endTime: any) => {
    if (this.date(startTime) === this.date(endTime)) {
      Toast.info('起止日期不能选择同一天，请重新选择入住时间！')
      return
    }
    this.setState(
      {
        show: false,
        startTime,
        endTime,
        startDate: this.date(startTime),
        endDate: this.date(endTime),
        days: this.day(startTime, endTime),
        defaultStartTime: startTime,
        defaultEndTime: endTime,
        totalDays: this.day(startTime, endTime),
      },
      () => {
        if (this.state.totalDays > 14) {
          this.setState({
            startDate: this.date(new Date(+now)),
            endDate: this.date(new Date(+now + (61920000))),
            totalDays: 1,
          })
          Toast.info('招待所预定周期最长14天，请重新选择入住时间！')
          return
        }
        this.genData()
      },
    )
  }
  // 日期换成想要的展示
  date(startTime: any) {
    const newDate =
      startTime.getFullYear() +
      '-' +
      (startTime.getMonth() + 1) +
      '-' +
      startTime.getDate()
    return newDate
  }

  // 计算两个日期间的天数
  day(startTime: any, endTime: any) {
    var diff = endTime.getTime() - startTime.getTime() //时间差的毫秒数

    //计算出相差天数
    var days = Math.floor(diff / (24 * 3600 * 1000))
    return days
  }
  getDateExtra = (date: any) => extra[+date]
  changeDate() {
    return (
      <div className="dorm-info-mid">
          <div className="time" onClick={() => this.onDateSelect.bind(this)()}>
            <div className="startLeft">
              <div className="top" style={{ color: '#434343', fontSize: '16px' }}>入住日期</div>
              <div className="bottom">{this.state.startDate}</div>
            </div>
            <div className="info">
              <div className="top" style={{ color: '#434343', fontSize: '16px' }}>离开日期</div>
              <div className="bottom">{this.state.endDate}</div>
            </div>
            <div style={{ marginRight: '0.2rem', color: '#434343', fontSize: '16px'}}>
              共{this.state.totalDays}晚 &nbsp;&gt;
            </div>
        </div>
        <Calendar
          {...this.state.config}
          visible={this.state.show}
          totalDays={this.state.totalDays}
          onCancel={this.onCancel}
          onConfirm={this.onConfirm}
          getDateExtra={this.getDateExtra}
          defaultDate={now}
          infiniteOpt = {true}
          minDate={new Date(+now)}
        />
      </div>
    )
  }
  // 预订信息
  getRoomInfo() {
    // 4：3图片比例
    const imgW = (window.screen.width - 32) / 2 
    const imgH = (imgW * 3 / 4) + 'px'
    const cellH = (imgW * 3 / 4) + 125 + 'px'
    return (
        <div className="imgList">
          {
            this.state.imgList.map((item:any,index:any)=>{
              return (
                <div className="imgList-item" style={{height: cellH}}  key={index}>
                <div className="left-tab" style={{border:'1px solid #eeeeee',borderRadius:'5px'}} onClick={() => this.bookInfo(item)}>
                    <div>
                      <div>
                        <img src={item.image&&item.image.length > 0 ? item.image[0].url : '/public/assets/img/picture.png'} alt="" style={{ width: '100%',height: imgH, objectFit: "cover"}} />
                      </div>
                      <div style={{ paddingTop:'10px'}}>
                        <span style={{ fontSize: '16px',padding:'5px', overflow: 'hidden',textOverflow: 'ellipsis' }}>{item.name}</span>
                        {/* <span style={{ fontSize: '14px', padding:'5px', }}>{item.property_name}</span> */}
                      </div>
                      <div className="between-row" style={{ padding:'5px' }}>
                        <span style={{ fontSize: '14px', color:'#cf6568' }}>{item.property === '3' ? item.month_price : item.day_price}{item.property === '3' ?'元/床/月':'元/天'}</span>
                        <span style={{ fontSize: '14px', color:'#888888' }}>{item.acreage}{item.acreage?'m²':''}</span>
                      </div>
                      <div className="between-row" style={{ padding:'5px' }}>
                        {item.property === '3' && this.state.isLineup === '1'? <span style={{ fontSize: '12px',padding:'5px',color: '#169bd5', width:'auto', minWidth: '57px' }}>排队:{item.queue_count}人</span> : null}
                        {item.property === '1' || this.state.isLineup === '0' ? <span style={{ fontSize: '12px',padding:'5px',color: '#169bd5', width:'auto', minWidth: '57px' }}>剩余:{item.bedCount}</span> : null}
                        {item.property === '1' || this.state.isLineup === '0' ? 
                          <Button type="primary" disabled={item.bedCount === '0'} style={{lineHeight: '20px', height: '20px', display: 'flex', alignItems: 'center', backgroundColor: '#cf6568'}}>
                            <span style={{fontSize: '12px'}}>预订</span>
                          </Button>
                        : null}
                        {item.property === '3' && this.state.isLineup === '1' ? 
                          <Button type="primary" style={{lineHeight: '20px', height: '20px', display: 'flex', alignItems: 'center', backgroundColor: '#cf6568'}}>
                            <span style={{fontSize: '12px'}}>排队</span>
                          </Button>
                        : null}
                      </div>
                    </div>
                  </div>
                </div>
              )
            })
          }
      </div>
    )
  }
  render() {
    return (
      // <div className="book-room-list" >
      <div className={phonePlatform() === 'iOS' ? 'book-room-list-hei' : 'book-room-list' }>
        {(cookie.get('app_Type') === '1') ?
          (this.state.showModal) ?
            <div>
              {(cookie.get('app_Type') === '1') && this.changeDate() }
              {this.state.imgList.length > 0 ? this.getRoomInfo():''}
              <Modal visible={this.state.showAlert} transparent title="提示" footer={[{ text: '确定', onPress: () => { this.setState({ showAlert: false }) } }]}>
                <span>{this.state.alertMsg}</span>
              </Modal>
            </div>
                : 
                (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',
                  height:'100%',width:'100%',background:'#ddd',opacity:'.5',position:'fixed',zIndex:100}}>
                    <div style={{ textAlign: 'center',marginTop:'-45px' }}>
                      <p style={{fontSize:'18px'}}>请先选择入住周期~</p>
                      <br />
                      <button className="go-btn" onClick={() => this.onDateSelect.bind(this)()}>去选择</button>
                    </div>
                </div>)
        : 
        (<div>
          {(cookie.get('app_Type') === '1') && this.changeDate() }
          {this.state.imgList.length > 0 ? this.getRoomInfo():''}
          <Modal visible={this.state.showAlert} transparent title="提示" footer={[{ text: '确定', onPress: () => { this.setState({ showAlert: false }) } }]}>
            <span>{this.state.alertMsg}</span>
          </Modal>
          </div>
        )}
      </div>
    )
  }
}